module.exports = __webpack_public_path__ + "static/img/6.e0e311fa.png";